import request from '@/utils/request'

//基础path
const basePath = "/api/resume/delivery";

/**
 * 简历投递
 * @param form
 */
export function saveResumeDeliveryRecord(params) {
    return request({
        url: `${basePath}/`,
        method: 'post',
        data: params
    })
}

/**
 * 获取单项投递记录
 * @param form
 */
export function findDeliveryRecord(id) {
    return request({
        url: `${basePath}/${id}`,
        method: 'get'
    })
}

/**
 * 获取企业投递记录
 * @param form
 */
export function findDeliveryRecordByCondition(params) {
    return request({
        url: `${basePath}/enterprise/page`,
        method: 'get',
        params: params
    })
}


/**
 * 更新投递简历的查阅状态
 * @param form
 */
export function updateReviewStatus(params) {
    return request({
        url: `${basePath}/${params.id}/${params.status}`,
        method: 'put'
    })
}

/**
 * 批量更新投递简历的查阅状态
 * @param form
 */
export function batchUpdateReviewStatus(params) {
    return request({
        url: `${basePath}//batch/${params.status}`,
        method: 'put',
        params: params
    })
}

/**
 * 批量导出简历
 * @param form
 */
export function importBaseInfo(params) {
    return request({
        url: `${basePath}/import`,
        method: 'post',
        params: params
    })
}
